import axios from "@/plugins/axios";

export default {
  getTripInclusion(env) {
    return axios.get(`/trip_inclusions/${env}`);
  },
  updateTripInclusion(env, included, excluded, disclaimer) {
    return axios.put(`/trip_inclusions/${env}`, { included, excluded, disclaimer });
  },
};
